var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.market)?_c('b-container',[_c('head-block',{attrs:{"title":_vm.$t('pages.bookings.market_terms')}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.market.paymentTerms)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }